const isInvalidInput = (seconds: number): boolean => {
  return isNaN(seconds) || seconds === Infinity || seconds < 0;
};

/**
 * Formats the duration in seconds into string.
 * Note: The `seconds` should not be negative.
 * TODO: Inventing wheels. Rewrite with date-fns.
 */
export function formatSecondsToDuration(seconds: number): string {
  // Note: this is actually doing floor()!
  const totalSeconds = parseInt(`${seconds}`, 10);

  const h = Math.floor(totalSeconds / 3600);
  const m = Math.floor((totalSeconds % 3600) / 60);
  const s = Math.floor(totalSeconds % 60);

  if (totalSeconds === 0 || isInvalidInput(totalSeconds)) {
    return '0s';
  } else {
    return [h && `${h}h`, (m || (h && s)) && `${m}m`, s && `${s}s`]
      .filter(Boolean)
      .join(' ');
  }
}

/**
 * Formats the duration between `first` and `second` into string.\
 * `second` should be larger (later) than `first`.
 * TODO: Inventing wheels. Rewrite with date-fns.
 */
export function formatDuration(first: string, second: string): string {
  const seconds = (Number(new Date(second)) - Number(new Date(first))) / 1000;
  if (isInvalidInput(seconds)) {
    return '0s';
  }

  return formatSecondsToDuration(seconds);
}
